import { Controller } from "@hotwired/stimulus"

// ビルの選び方（既存ビルを選択／既存ビルを検索／新しいビルとして登録）に応じて、
// 選んだ経路のブロックだけを開く。新規ビルの入力欄は「新しいビルとして登録」のときだけ出す。
//
// 隠した経路の選択には触らない。候補と検索リストは name が別（property_id /
// search_property_id）で、どちらを採るかはサーバ側が選び方から決めるため、
// 選び方を往復しても各経路で選んだビルはそのまま残る。
export default class extends Controller {
  static targets = ["mode", "candidateBlock", "searchBlock", "fields"]

  declare readonly modeTargets: HTMLInputElement[]
  declare readonly hasCandidateBlockTarget: boolean
  declare readonly candidateBlockTarget: HTMLElement
  declare readonly hasSearchBlockTarget: boolean
  declare readonly searchBlockTarget: HTMLElement
  declare readonly hasFieldsTarget: boolean
  declare readonly fieldsTarget: HTMLElement

  // 配下のコントローラ（property-map）が接続してから合図を出す。Stimulus は
  // 祖先を先に接続するので、connect の中で直接投げると誰も受け取らない
  connect() {
    queueMicrotask(() => this.apply())
  }

  choose() {
    this.apply()
  }

  private apply() {
    const mode = this.modeTargets.find((radio) => radio.checked)?.value ?? "new"

    if (this.hasCandidateBlockTarget) this.candidateBlockTarget.classList.toggle("hidden", mode !== "candidate")
    if (this.hasSearchBlockTarget) this.searchBlockTarget.classList.toggle("hidden", mode !== "search")
    if (!this.hasFieldsTarget) return

    this.fieldsTarget.classList.toggle("hidden", mode !== "new")
    if (mode === "new") this.notifyFieldsShown()
  }

  // 地図の再描画と住所からの座標自動取得は form-steps のステップ表示イベントで動く。
  // この画面は form-steps を使わないので、入力欄を開いたときに同じ合図を出す。
  private notifyFieldsShown() {
    window.dispatchEvent(
      new CustomEvent("form-steps:step-shown", { detail: { step: this.fieldsTarget } })
    )
  }
}
